import renderWhenVisible from '@/components/render-when-visible'
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default Vue.extend({

  computed: {
    ...mapGetters({
      pageCategory: 'page/getCategory',
    }),
    pageLevels () {
      return this.pageCategory?.uriCategory?.levels ?? []
    },
  },

  components: {
    ozSeoWidgetsCards: renderWhenVisible(() => import(/* webpackChunkName: "oz-seo-widgets-cards" */ '@/components/seo/oz-seo-widgets-cards')),
  },

})
